module.exports = __webpack_public_path__ + "img/import-file-light.60de6cf.svg";